import { action } from 'satcheljs';

export const reloadReadingPaneAfterClosingSxS = action('reloadReadingPaneAfterClosingSxS');

export const onSxSChangeOrClose = action(
    'onSxSChangeOrClose',
    (selectedLinkId: string | null, isSelectedLinkReadOnly?: boolean) => ({
        selectedLinkId,
        isSelectedLinkReadOnly,
    })
);
